import { render } from "./ExpertiseWidget.vue?vue&type=template&id=5ea5ffa2"
import script from "./ExpertiseWidget.vue?vue&type=script&lang=js"
export * from "./ExpertiseWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__